import request from '@/utils/request'
import { Message } from 'element-ui'

/**
 * 文件上传公共方法
 * @param {File} file - 文件对象
 * @param {Object} options - 配置选项
 * @param {String} options.type - 上传类型 (avatar/certificate/course_cover/course_material)
 * @param {Function} options.onProgress - 上传进度回调
 * @param {Number} options.maxSize - 最大文件大小(MB)，默认10MB
 * @param {Array} options.accept - 允许的文件类型，如 ['image/jpeg', 'image/png']
 * @returns {Promise}
 */
export function uploadFile(file, options = {}) {
    const {
        type = 'avatar',
        onProgress,
        maxSize = 10,
        accept = []
    } = options

    // 文件大小验证
    if (file.size / 1024 / 1024 > maxSize) {
        Message.error(`文件大小不能超过 ${maxSize}MB`)
        return Promise.reject(new Error(`文件大小超过限制`))
    }

    // 文件类型验证
    if (accept.length > 0 && !accept.includes(file.type)) {
        Message.error('文件类型不支持')
        return Promise.reject(new Error('文件类型不支持'))
    }

    const formData = new FormData()
    formData.append('file', file)
    formData.append('dir', type)

    return request({
        url: '/common/upload',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
            if (onProgress) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                onProgress(percentCompleted)
            }
        }
    })
}

/**
 * 上传头像
 * @param {File} file - 图片文件
 * @param {Function} onProgress - 进度回调
 * @returns {Promise}
 */
export function uploadAvatar(file, onProgress) {
    return uploadFile(file, {
        type: 'avatar',
        maxSize: 5,
        accept: ['image/jpeg', 'image/png', 'image/jpg'],
        onProgress
    })
}

/**
 * 上传资质证明
 * @param {File} file - 文件
 * @param {Function} onProgress - 进度回调
 * @returns {Promise}
 */
export function uploadCertificate(file, onProgress) {
    return uploadFile(file, {
        type: 'certificate',
        maxSize: 10,
        accept: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'],
        onProgress
    })
}

/**
 * 上传课程封面
 * @param {File} file - 图片文件
 * @param {Function} onProgress - 进度回调
 * @returns {Promise}
 */
export function uploadCourseCover(file, onProgress) {
    return uploadFile(file, {
        type: 'course_cover',
        maxSize: 5,
        accept: ['image/jpeg', 'image/png', 'image/jpg'],
        onProgress
    })
}

/**
 * 上传课程资料
 * @param {File} file - 文件
 * @param {Function} onProgress - 进度回调
 * @returns {Promise}
 */
export function uploadCourseMaterial(file, onProgress) {
    return uploadFile(file, {
        type: 'course_material',
        maxSize: 100,
        onProgress
    })
}
